module.exports = __webpack_public_path__ + "img/新样式2.acb43b09.jpg";